import { render } from "./Hotspot3.vue?vue&type=template&id=7ad55d5d&scoped=true&ts=true"
import script from "./Hotspot3.vue?vue&type=script&lang=ts"
export * from "./Hotspot3.vue?vue&type=script&lang=ts"

import "./Hotspot3.vue?vue&type=style&index=0&id=7ad55d5d&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad55d5d"]])

export default __exports__